/* eslint-disable array-callback-return */
import React, { useEffect, useState, useRef } from 'react';
import clsx from 'clsx';
import hamburgerMenu from "../../../../assets/images/icon_actions/hamburgerMenu.svg";
import star from "../../../../assets/images/starNew.png";
import { Row, Col, Dropdown, Menu, Image } from "antd";
import { RadioGroup, FormControlLabel, Radio } from "@mui/material";
import { NavLink } from "react-router-dom";
import customStyles from "../../../../assets/styles/customStyles";
import { currencyFormat, downloadImageCommon, currencyFormatInt, exportChatFile } from "../../../../helpers/utilities";
import { SelectedIcon, UnSelectedIcon } from "../Icons/selectedIcon";
import useMediaQuery from '@mui/material/useMediaQuery';

export const TopTen = (props) => {
    const { title, details } = props;
    const topTen = useRef('null');
    const classes = customStyles();
   // const [category, setCategory] = useState([]);
    const [type, setType] = useState('top_suppliers_amount');
    const [data, setData] = useState(60);
    const [cValue, setCValue] = useState('invoices');
    const [datas, setDatas] = useState([]);
    const [yTitle, setYtitle] = useState('Total Value');
    //const [yFields, setYFields] = useState([]);
    //const [colors, setColors] = useState([classes.topGreen, classes.topOrange, classes.topBlue]);
    const colors = [classes.topGreen, classes.topOrange, classes.topBlue];
    const mobileDevice = useMediaQuery('(min-width:1300px)');
    let cI = 0;
    const handleChange = (value) => {
        setType(value);
        if (value === 'top_suppliers_amount') {
            setYtitle('Total Value');
        } else if (value === 'top_suppliers_invoice') {
            setYtitle('Total Transactions');
        }
    }

    const handleImageDownload = (type) => {
        if (type === 'csv') {
            exportFile();
        } else {
            downloadImageCommon(topTen.current, title, type);
        }
    }

    const exportFile = () => {
        let newHead = [];
        if (cValue === 'invoiceAmount') {
            newHead = [
                ['Name', 'Balance Due', yTitle]
            ];
        } else {
            newHead = [
                ['Name', yTitle]
            ];
        }
        datas.map((data, i) => {
            if (cValue === 'invoiceAmount') {
                newHead[newHead.length] = [data?.name, data?.balanceAmount, data?.invoiceAmount];
            } else {
                newHead[newHead.length] = [data?.name, data?.invoices];
            }
        });
        exportChatFile(`${title}_${yTitle}`, newHead);
    }

    const handleRangeChange = (value) => {
        setData(value);
    }

    useEffect(() => {
        let leg = details[`${type}_${data}`];
        let x = [];
        let y = [];
        let v = 'invoices';
        if (type === 'top_suppliers_amount') {
            v = 'invoiceAmount'
        }
        setCValue(v);
        leg.length > 0 && leg.map((item, i) => {
            x.push(i + 1);
            y.push(item[v]);
        });
        // setCategory(x);
        // setYFields(y);
        setDatas(details[`${type}_${data}`]);

    }, [details, type, data]);


    

    return (
        <div ref={topTen} className={clsx(classes.totalChartDiv, classes.topTenChart)}>
            <div className={clsx(classes.monthlyDivTitle, classes.bold)}><span>{title}</span>
                <span className={clsx({ [classes.marginLeft20]: mobileDevice })}>
                    <RadioGroup
                        row
                        className={clsx(classes.monthlyDivTitleRadio)}
                        defaultValue={"top_suppliers_amount"}
                        onChange={(e) => handleChange(e.target.value)}>
                        <FormControlLabel value="top_suppliers_amount" control={<Radio
                            checkedIcon={<UnSelectedIcon />}
                            icon={<SelectedIcon />}
                        />} label="By Value" />
                        <FormControlLabel value="top_suppliers_invoice" control={<Radio
                            checkedIcon={<UnSelectedIcon />}
                            icon={<SelectedIcon />}
                        />} label="By Transactions" />
                    </RadioGroup>
                    <div className={clsx(classes.monthlyDivTitle, classes.topTenTitle, classes.bold)}>
                        <RadioGroup
                            row
                            defaultValue={data}
                            onChange={(e) => handleRangeChange(e.target.value)}>
                            <FormControlLabel value="60" control={<Radio
                                checkedIcon={<UnSelectedIcon />}
                                icon={<SelectedIcon />}
                            />} label="60 Days" />
                            <FormControlLabel value="120" control={<Radio
                                checkedIcon={<UnSelectedIcon />}
                                icon={<SelectedIcon />}
                            />} label="120 Days" />
                            <FormControlLabel value="300" control={<Radio
                                checkedIcon={<UnSelectedIcon />}
                                icon={<SelectedIcon />}
                            />} label="300 Days" />
                        </RadioGroup>
                    </div>
                </span>
                <span className={classes.hamburgerMenu}>
                    <Dropdown
                        placement="bottomLeft"
                        trigger={['click']}
                        overlay={
                            <Menu className={clsx(classes.groupMenu, classes.hamburgeGroupMenu)}>
                                <Menu.Item><NavLink to={'#'} onClick={() => handleImageDownload('png')}>Download PNG</NavLink></Menu.Item>
                                <Menu.Item><NavLink to={'#'} onClick={() => handleImageDownload('csv')}>Download CSV</NavLink></Menu.Item>
                            </Menu>
                        }>
                        <Image src={hamburgerMenu} preview={false} />
                    </Dropdown>
                </span>
            </div>
            <div className={classes.chartTopSuppliers}>
                {/* <div className={classes.chartImage}>
                    <div className={classes.chartDiv}>
                        {
                            category.length > 0 ?
                                <><ReactApexChart options={chartData} series={chartData.series} height={mobileDevice ? 175 : 125} />
                                    <div className={classes.invoiceAmount}>{yTitle}</div></> :
                                <div style={{ height: 150 }}>No results found</div>
                        }
                    </div>
                </div> */}
            </div>
            <div className={clsx(classes.overFolwBigContent, classes.scrollBarLight)} style={{ height: "calc(100% - 60px)", paddingTop: 13 }}>
                <Row gutter={40}>
                    {
                        datas.length > 0 ? datas.map((data, i) => {
                            if (cI >= 3) {
                                cI = 0;
                            }
                            cI += 1;
                            return (
                                <Col key={i} span={12} className={clsx(classes.totalSupDetails, { [classes.margin25t]: i >= 2 }, colors[cI - 1])} >
                                    <Row>
                                        <Col span={12} className={clsx(classes.positionRelative)}>
                                            <span className={clsx(classes.supNumsimicir)}>
                                                {
                                                    i === 0 && <img alt="Star" className={clsx(classes.supNumsStar)} src={star} />
                                                }
                                                <span className={clsx(classes.supNum)}>{(i + 1).toString().padStart(2, '0')}</span>
                                            </span>
                                        </Col>
                                        <Col span={12} className={clsx(classes.textAlignRight)}>
                                            {
                                                cValue === 'invoiceAmount' ? <><p>Balance Due</p>
                                                    <h6>₹ {currencyFormat(data?.balanceAmount)}</h6>
                                                    <p className={clsx(classes.padding5t)}>Total Invoice Value</p>
                                                    <h6>₹ {currencyFormatInt(data?.invoiceAmount)}</h6></> :
                                                    <>
                                                        <p style={{ opacity: 0 }}>Balance Due</p>
                                                        <h6 style={{ opacity: 0 }}>₹ {currencyFormat(data?.balanceAmount)}</h6>
                                                        <p className={clsx(classes.padding5t)}>Total Transactions</p>
                                                        <h6>{currencyFormatInt(data?.invoices)}</h6>
                                                    </>
                                            }
                                        </Col>
                                        <Col span={24} className={clsx(classes.supName)}>{data?.name}</Col>
                                    </Row>
                                </Col>
                            )
                        }) : <Col span={24}> No results found</Col>
                    }
                </Row>
            </div>
        </div>
    )
}